package modysy.simulation

import modysy.model.{Agent, GameObject}
import modysy.simulation.pp.State

object Behaviours {
  private val speed = 2

  private def closestOneWithState(
      agent: Agent,
      otherAgents: Seq[Agent],
      stateName: String
  ): Option[Agent] = {
    val otherAgentsWithState =
      otherAgents.filter(a => !a.eq(agent) && a.state.name == stateName)

    if (otherAgentsWithState.nonEmpty)
      Some(
        otherAgentsWithState.minBy(
          a =>
            (a.body.pose.translation - agent.body.pose.translation).squaredNorm
        )
      )
    else None
  }

  def chasingBehaviour(
      victimStateName: String,
      speed: Int
  ): (Agent, Seq[GameObject]) => Unit =
    (agent, objects) => {

      val agents = objects
        .filter(_.isInstanceOf[Agent])
        .map(_.asInstanceOf[Agent])

      val victimAgent = closestOneWithState(agent, agents, victimStateName)
      agent.body.velocity.linear = victimAgent match {
        case Some(v) =>
          (v.body.pose.translation - agent.body.pose.translation).unit * speed
        case None => 0
      }

    }

  def fleeingBehaviour(
      victimStateName: String,
      speed: Int
  ): (Agent, Seq[GameObject]) => Unit =
    (agent, objects) => {

      val agents = objects
        .filter(_.isInstanceOf[Agent])
        .map(_.asInstanceOf[Agent])

      val victimAgent = closestOneWithState(agent, agents, victimStateName)
      agent.body.velocity.linear = victimAgent match {
        case Some(v) =>
          (agent.body.pose.translation - v.body.pose.translation).unit * speed
        case None => 0
      }

    }

  def noBehaviour(): (Agent, Seq[GameObject]) => Unit = (agent, objects) => {}

  def blockingBehaviour(): (Agent, Seq[GameObject]) => Unit =
    (agent, objects) => {
      agent.body.velocity.linear = 0
    }

  /*def applyBehaviours(agents: Seq[Agent]): Unit = {
    for (agent <- agents) {
      val victim_state = agent.state.name match {
        case "+L" => Some("-")
        case "-L" => Some("+")
        case _    => None
      }

      val victim_agent =
        victim_state.flatMap(closestOneWithState(agent, agents, _))

      agent.body.velocity.linear = victim_agent match {
        case Some(v) =>
          (v.body.pose.translation - agent.body.pose.translation).unit * speed
        case None => 0
      }
    }
  }*/

}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/2d4fb5cd/0/mtv-pr-2018/modysy-product/src/main/scala/modysy/simulation/Behaviours.scala